document.addEventListener('DOMContentLoaded', () => {
  const upsellRoot = document.getElementById('upsell-product-container');
  const addBtn = document.getElementById('upsell-product-add-btn');
  const totalEl = document.getElementById('upsell-product-price');
  const mainCheckbox = upsellRoot.querySelector('.upsell-product-checkbox[data-role="main"]');
  const currencyCode = "{{ shop.currency }}";
  const variantInputEl = document.querySelector('form[action^="/cart/add"] [name="id"]') || document.querySelector('product-form [name="id"]');
  const errorEl = document.getElementById('cart-error');

  if (errorEl) {
    errorEl.setAttribute('role', 'alert');
    errorEl.setAttribute('aria-live', 'polite');
    errorEl.hidden = true;
  }

  const showError = (msg) => {
    if (addBtn) addBtn.setAttribute('data-error', msg || '');
    if (errorEl) {
      errorEl.textContent = msg || '';
      if (msg) errorEl.classList.add('is-visible');
      else errorEl.classList.remove('is-visible');
    }
  };

  const clearError = () => {
    if (addBtn) addBtn.removeAttribute('data-error');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }
  };

  const isFr = (() => {
    const el = document.getElementById('upsell-product-container');
    if (!el) return false;
    return el.dataset.isFr === 'true' || (el.dataset.locale || '').toLowerCase().startsWith('fr');
  })();

  const formatMoney = (cents) => {
    const v = (Number(cents) || 0) / 100;
    if (isFr) {
      try {
        const num = v.toLocaleString('fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return `${num} $`;
      } catch (e) {
        return `${v.toFixed(2)} $`;
      }
    }
    try {
      let out = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(v);
      out = out.replace(/(\D)0{2}\b/, '$1');
      return out;
    } catch (e) {
      const raw = '$' + v.toFixed(2);
      return raw.replace(/\.00\b/, '');
    }
  };

  const parseMoneyToCents = (text) => {
    if (!text) return 0;
    const n = (text.replace(/[^0-9.,]/g,'').replace(/,/g,'').match(/[0-9]*\.?[0-9]+/)||[])[0];
    return n ? Math.round(parseFloat(n) * 100) : 0;
  };

  const computeDiscounted = (baseCents, mode, val) => {
    if (!baseCents || !mode || !isFinite(val)) return baseCents;
    let out = baseCents;
    if (mode === 'percent') {
      const off = Math.round((baseCents * val) / 100);
      out = baseCents - off;
    } else if (mode === 'amount') {
      out = baseCents - Math.round(val);
    }
    return out < 0 ? 0 : out;
  };

  const inferMainDiscountOnce = () => {
    if (!mainCheckbox || mainCheckbox.dataset._discInit === '1') return;

    const priceRoot = document.querySelector('[id^="price-"]');
    const el = priceRoot && (priceRoot.querySelector('.price-item--sale') || priceRoot.querySelector('.price-item--regular') || priceRoot);
    const baseCents = parseMoneyToCents(el && el.textContent);
    const discountedCents = parseInt(mainCheckbox.dataset.price || '0', 10);

    if (!baseCents || !discountedCents || discountedCents >= baseCents) {
      mainCheckbox.dataset._discInit = '1';
      return;
    }

    const amountOff = baseCents - discountedCents;
    const percentOffRaw = baseCents ? (amountOff * 100) / baseCents : 0;
    const percentOffRounded = Math.round(percentOffRaw);

    let mode = 'amount';
    let val = amountOff;

    if (percentOffRounded > 0 && percentOffRounded < 100 && Math.abs(percentOffRaw - percentOffRounded) < 0.75) {
      mode = 'percent';
      val = percentOffRounded;
    }

    mainCheckbox.dataset._discMode = mode;
    mainCheckbox.dataset._discVal = String(val);
    mainCheckbox.dataset._discInit = '1';
  };

  const updateMainPriceUI = (baseCents, discountedCents, hasDiscount) => {
    const mainCard = upsellRoot.querySelector('.custom-main');
    if (!mainCard) return;

    let compareEl = mainCard.querySelector('.price-compare');
    let saleEl = mainCard.querySelector('.price-sale');
    const priceEls = mainCard.querySelectorAll('.custom-price');

    if (hasDiscount && discountedCents < baseCents) {
      if (!compareEl) {
        compareEl = document.createElement('s');
        compareEl.className = 'price-compare';
        priceEls[0]?.before(compareEl);
      }
      compareEl.textContent = isFr
        ? `${(baseCents/100).toLocaleString('fr-CA', { minimumFractionDigits:2, maximumFractionDigits:2 })} $`
        : formatMoney(baseCents);

      if (!saleEl) {
        saleEl = document.createElement('span');
        saleEl.className = 'custom-price price-sale';
        priceEls[priceEls.length-1]?.after(saleEl);
      }
      saleEl.textContent = isFr
        ? `${(discountedCents/100).toLocaleString('fr-CA', { minimumFractionDigits:2, maximumFractionDigits:2 })} $`
        : formatMoney(discountedCents);

      if (priceEls.length) priceEls[0].textContent = '';
    } else {
      if (compareEl) compareEl.remove();
      if (saleEl) saleEl.remove();
      if (priceEls.length) {
        priceEls[0].textContent = isFr
          ? `${(baseCents/100).toLocaleString('fr-CA', { minimumFractionDigits:2, maximumFractionDigits:2 })} $`
          : formatMoney(baseCents);
      }
    }
  };

  const getCurrentVariantId = () => {
    if (variantInputEl && variantInputEl.value) return parseInt(variantInputEl.value, 10);
    return mainCheckbox ? parseInt(mainCheckbox.dataset.variantId, 10) : null;
  };

  const sumSelectedCents = () => {
    let s = 0;
    upsellRoot.querySelectorAll('.upsell-product-checkbox').forEach(cb => {
      if (cb.checked || cb.dataset.role === 'main') s += parseInt(cb.dataset.price || '0', 10);
    });
    return s;
  };

  const renderSummary = () => {
    totalEl.textContent = formatMoney(sumSelectedCents());
  };

  const syncMainPrice = () => {
    const priceRoot = document.querySelector('[id^="price-"]');
    if (!priceRoot || !mainCheckbox) { renderSummary(); return; }

    const el = priceRoot.querySelector('.price-item--sale') || priceRoot.querySelector('.price-item--regular') || priceRoot;
    const baseCents = parseMoneyToCents(el && el.textContent);
    if (!baseCents) { renderSummary(); return; }

    inferMainDiscountOnce();

    const mode = mainCheckbox.dataset._discMode || '';
    const val = parseFloat(mainCheckbox.dataset._discVal || '0');
    const hasDiscount = !!(mainCheckbox.dataset.discount) && !!mode && isFinite(val) && val > 0;

    const discounted = hasDiscount ? computeDiscounted(baseCents, mode, val) : baseCents;

    mainCheckbox.dataset.price = String(discounted);
    updateMainPriceUI(baseCents, discounted, hasDiscount);
    renderSummary();
  };

  const onVariantChange = () => {
    const id = getCurrentVariantId();
    if (id && mainCheckbox) mainCheckbox.dataset.variantId = String(id);
    syncMainPrice();
  };

  upsellRoot.querySelectorAll('.upsell-product-checkbox').forEach(cb => {
    cb.addEventListener('change', () => {
      if (cb.dataset.role === 'main') { cb.checked = true; return; }
      renderSummary();
    });
  });

  ['variant:change','variant:changed','variantChange'].forEach(ev => {
    document.addEventListener(ev, () => { requestAnimationFrame(onVariantChange); });
  });

  if (variantInputEl) {
    variantInputEl.addEventListener('change', onVariantChange);
    new MutationObserver(onVariantChange).observe(variantInputEl, { attributes: true, attributeFilter: ['value'] });
  }

  const priceRootObs = document.querySelector('[id^="price-"]');
  if (priceRootObs) new MutationObserver(syncMainPrice).observe(priceRootObs, { childList: true, subtree: true, characterData: true });

  const fetchSectionsJSON = ids =>
    fetch('/?sections=' + ids.join(','), { credentials: 'same-origin' }).then(r => r.json());

  const replaceSectionHTML = (id, html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const next = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
    const curr = document.querySelector('#shopify-section-' + id);
    if (next && curr) curr.replaceWith(next);
    const nextDrawer = tmp.querySelector('cart-drawer');
    const currDrawer = document.querySelector('cart-drawer');
    if (nextDrawer && currDrawer) currDrawer.replaceWith(nextDrawer);
    const nextItems = tmp.querySelector('cart-drawer-items');
    const currItems = document.querySelector('cart-drawer-items');
    if (nextItems && currItems) currItems.replaceWith(nextItems);
  };

  const openCartDrawer = () => {
    const el = document.querySelector('cart-drawer');
    if (el && typeof el.open === 'function') { el.open(); return; }
    if (el && typeof el.openDrawer === 'function') { el.openDrawer(); return; }
    const d = document.getElementById('CartDrawer');
    if (d) { d.classList.add('is-open'); document.documentElement.classList.add('js-drawer-open'); }
  };

  const globalCodes = (upsellRoot.dataset.discounts || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const gatherSelectedDiscountCodes = () => {
    const set = new Set(globalCodes);
    upsellRoot.querySelectorAll('.upsell-product-checkbox').forEach(cb => {
      if (cb.checked || cb.dataset.role === 'main') {
        const code = (cb.dataset.discount || '').trim();
        if (code) set.add(code);
      }
    });
    return Array.from(set);
  };

  const applyDiscountCodes = (codes) => {
    if (!codes.length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(r => r.json().catch(() => ({})));
  };

  addBtn.addEventListener('click', () => {
    clearError();
    const items = [];
    const mainVariantId = getCurrentVariantId();
    if (mainVariantId) items.push({ id: mainVariantId, quantity: 1 });
    upsellRoot.querySelectorAll('.upsell-product-checkbox:not([data-role="main"])').forEach(cb => {
      if (cb.checked) {
        const id = parseInt(cb.dataset.variantId, 10);
        if (id) items.push({ id, quantity: 1 });
      }
    });
    if (!items.length) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items }),
      credentials: 'same-origin'
    })
    .then(r => r.json().then(j => ({ ok: r.ok, j })).catch(() => ({ ok: r.ok, j: {} })))
    .then(({ ok, j }) => {
      if (!ok) throw new Error(j.message || j.description || 'Failed to add to cart');
    })
    .then(() => {
      const codes = gatherSelectedDiscountCodes();
      return applyDiscountCodes(codes);
    })
    .then(() => fetchSectionsJSON(['cart-drawer','cart-icon-bubble']))
    .then(data => {
      clearError();
      if (data['cart-drawer']) replaceSectionHTML('cart-drawer', data['cart-drawer']);
      if (data['cart-icon-bubble']) replaceSectionHTML('cart-icon-bubble');
      requestAnimationFrame(openCartDrawer);
    })
    .catch(e => {
      const msg = e?.message ?? '';
      const isMaxQty = /maximum quantity of this item is already in your cart/i.test(msg);
      showError(
        isFr
          ? (isMaxQty ? 'La quantité maximale de cet article est déjà dans votre panier.' : 'Erreur inconnue')
          : (isMaxQty ? 'The maximum quantity of this item is already in your cart.' : 'Unknown error')
      );
    });
  });

  onVariantChange();
  syncMainPrice();
  renderSummary();
});